import React, { useEffect, useState } from "react";
import { Box, Typography, Button, TextField, InputAdornment } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";

import { fetchCustomerValues } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function SmCustomerValueListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const vals = await fetchCustomerValues(businessDomainId);
        setRows(Array.isArray(vals) ? vals : []);
      } catch (e) {
        notify.apiError(e);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessDomainId]);

  const filteredRows = searchText
    ? rows.filter((r) => r.successFactorName?.toLowerCase().includes(searchText.toLowerCase()))
    : rows;

  const columns = [
    { field: "successFactorName", headerName: t("successFactor.name"), flex: 1, minWidth: 200 },
    { field: "successFactorDescription", headerName: t("successFactor.description"), flex: 1, minWidth: 200 },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("customerValue.list.title")}</Typography>
        <TextField size="small" placeholder={t("common.search")} value={searchText} onChange={(e) => setSearchText(e.target.value)} InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment> }} />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate(`/design/${businessDomainId}/strategy-map/customer-values/create`)}
        >
          {t("common.add")}
        </Button>
      </Box>
      <DataGrid
        rows={filteredRows}
        columns={columns}
        getRowId={(r) => r.successFactorId}
        loading={loading}
        autoHeight
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        onRowClick={(p) => navigate(`/design/${businessDomainId}/strategy-map/customer-values/${p.row.successFactorId}`)}
        sx={{ "& .MuiDataGrid-row": { cursor: "pointer" } }}
      />
    </Box>
  );
}
